import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models/ValuableNode'

export class SchemaReferenceNode extends ValuableNode {
  @fromSpecific()
  @reactive()
  ref?: string
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Reference': SchemaReferenceNode
  }
}
